(() => {
  const qs = (s,c=document)=>c.querySelector(s);
  const qsa = (s,c=document)=>[...c.querySelectorAll(s)];
  const root = window.Shopify?.routes?.root || '/';
  const lang = (document.documentElement.lang||'en').slice(0,2);
  const FR = {
    'Unable to load your bag.':'Impossible de charger votre panier.',
    'Decrease quantity':'Diminuer la quantité',
    'Quantity':'Quantité',
    'Increase quantity':'Augmenter la quantité',
    'Remove':'Retirer',
    'Your bag is empty.':'Votre panier est vide.',
    'Pick 2 products — your 3rd is FREE':'Choisissez 2 produits — le 3e est OFFERT',
    '1 more product until your 3rd is FREE':'Plus qu’1 produit pour recevoir le 3e OFFERT',
    '🎁 Done! Add your 3rd product — it’s FREE':'🎁 C’est bon ! Ajoutez votre 3e produit — il est OFFERT',
    '🎁 Your 3rd product is FREE — already applied to your total':'🎁 Votre 3e produit est OFFERT — déjà déduit du total',
    'Unable to add item.':'Impossible d’ajouter l’article.',
    'Added to your bag.':'Ajouté à votre panier.',
    'Please choose your combination.':'Veuillez choisir votre combinaison.',
    'No results yet.':'Pas encore de résultats.'
  };
  const t = (nl,en,de)=> lang==='nl' ? nl : (lang==='de'&&de!==undefined ? de : (lang==='fr' ? (FR[en]||en) : en));
  let I18N_IMGS = {};
  try { I18N_IMGS = JSON.parse(document.getElementById('sclptiq-i18n-imgs')?.textContent||'{}'); } catch(e) {}

  function trapFocus(container){
    const focusable=qsa('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])',container).filter(el=>!el.disabled);
    if(!focusable.length)return()=>{};
    const first=focusable[0],last=focusable[focusable.length-1];
    const handler=e=>{
      if(e.key==='Escape'){container.hidden=true;return;}
      if(e.key!=='Tab')return;
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    };
    container.addEventListener('keydown',handler);first.focus();
    return()=>container.removeEventListener('keydown',handler);
  }

  async function fetchCart(){
    const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
    if(!r.ok)throw new Error(t('Je winkelmand kan niet worden geladen.','Unable to load your bag.','Dein Warenkorb konnte nicht geladen werden.'));
    return r.json();
  }

  function money(cents){
    return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(cents/100);
  }

  async function renderCart(){
    const cart=await fetchCart();
    qsa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    qsa('[data-cart-subtotal]').forEach(el=>el.textContent=money(cart.total_price));
    const container=qs('[data-cart-items]');
    if(container){
      container.innerHTML=cart.items.map(item=>{
        const variant=item.variant_title&&item.variant_title!=='Default Title'?`<p class="v2-cline__variant">${item.variant_title}</p>`:'';
        return `
        <article class="v2-cline" data-key="${item.key}">
          <a class="v2-cline__imgwrap" href="${item.url}"><img class="v2-cline__img" src="${(item.handle&&I18N_IMGS[item.handle])||item.image||''}" alt="" loading="lazy"></a>
          <div class="v2-cline__info">
            <a class="v2-cline__title" href="${item.url}">${item.product_title}</a>
            ${variant}
            <div class="v2-cline__row">
              <div class="v2-cline__qty">
                <button type="button" data-cart-dec="${item.key}" aria-label="${t('Aantal verlagen','Decrease quantity','Menge verringern')}">&minus;</button>
                <input type="text" inputmode="numeric" value="${item.quantity}" data-cart-quantity="${item.key}" aria-label="${t('Aantal','Quantity','Menge')}" readonly>
                <button type="button" data-cart-inc="${item.key}" aria-label="${t('Aantal verhogen','Increase quantity','Menge erhöhen')}">+</button>
              </div>
              <span class="v2-cline__price">${money(item.final_line_price)}</span>
            </div>
            <button type="button" class="v2-cline__remove" data-cart-remove="${item.key}">${t('Verwijderen','Remove','Entfernen')}</button>
          </div>
        </article>`;}).join('')||`<p class="v2-cart__empty">${t('Je winkelmand is leeg.','Your bag is empty.','Dein Warenkorb ist leer.')}</p>`;
    }
    const drawer=qs('[data-cart-drawer]'); if(drawer)drawer.classList.toggle('is-empty',cart.item_count===0);
    // Reward progress: 2 qualifying products -> 3rd (cheapest) free
    const rewardHandles=['sclptiq-gua-sha-cream','sclptiq-collagen-stick'];
    const qual=cart.items.reduce((n,it)=>n+(rewardHandles.indexOf(it.handle)>-1?it.quantity:0),0);
    const rewardFill=qs('[data-reward-fill]'); if(rewardFill)rewardFill.style.width=(Math.min(qual/2,1)*100)+'%';
    const rewardMsg=qs('[data-reward-msg]');
    if(rewardMsg){
      if(qual===0)rewardMsg.textContent=t('Kies 2 producten — je 3e is GRATIS','Pick 2 products — your 3rd is FREE','Wähle 2 Produkte — dein 3. ist GRATIS');
      else if(qual===1)rewardMsg.textContent=t('Nog 1 product tot je GRATIS 3e product','1 more product until your 3rd is FREE','Noch 1 Produkt bis zu deinem GRATIS 3. Produkt');
      else if(qual===2)rewardMsg.textContent=t('🎁 Gelukt! Voeg je 3e product toe — die is GRATIS','🎁 Done! Add your 3rd product — it’s FREE','🎁 Geschafft! Füg dein 3. Produkt hinzu — es ist GRATIS');
      else rewardMsg.textContent=t('🎁 Je 3e product is GRATIS — al verrekend in je totaal','🎁 Your 3rd product is FREE — already applied to your total','🎁 Dein 3. Produkt ist GRATIS — bereits verrechnet');
    }
    const rewardTile=qs('[data-reward-tile-gift]'); if(rewardTile)rewardTile.classList.toggle('is-on',qual>=2);
    return cart;
  }

  async function addItems(items){
    const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await r.json();
    if(!r.ok)throw new Error(data.description||t('Product kan niet worden toegevoegd.','Unable to add item.','Produkt konnte nicht hinzugefügt werden.'));
    await renderCart();
    const drawer=qs('[data-cart-drawer]'); if(drawer){drawer.hidden=false;trapFocus(drawer);}
    const live=qs('[data-cart-live]'); if(live)live.textContent=t('Toegevoegd aan je winkelmand.','Added to your bag.','Zu deinem Warenkorb hinzugefügt.');
  }

  document.addEventListener('submit',async e=>{
    const form=e.target.closest('form[action*="/cart/add"]'); if(!form)return;
    e.preventDefault(); const btn=qs('[type="submit"]',form),status=qs('.form-status',form);
    btn?.setAttribute('aria-busy','true');
    try{const fd=new FormData(form);await addItems([{id:Number(fd.get('id')),quantity:Number(fd.get('quantity')||1)}]);if(status)status.textContent=t('Toegevoegd aan je winkelmand.','Added to your bag.','Zu deinem Warenkorb hinzugefügt.');}
    catch(err){if(status)status.textContent=err.message;}
    finally{btn?.removeAttribute('aria-busy');}
  });

  document.addEventListener('click',async e=>{
    const open=e.target.closest('[data-cart-open]'); if(open){await renderCart();const d=qs('[data-cart-drawer]');d.hidden=false;trapFocus(d);}
    const close=e.target.closest('[data-cart-close]'); if(close)qs('[data-cart-drawer]').hidden=true;
    const remove=e.target.closest('[data-cart-remove]'); if(remove){await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})});await renderCart();}
    const dec=e.target.closest('[data-cart-dec]'); if(dec){const inp=dec.parentElement.querySelector('[data-cart-quantity]');const q=Math.max(0,Number(inp.value)-1);await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:dec.dataset.cartDec,quantity:q})});await renderCart();}
    const inc=e.target.closest('[data-cart-inc]'); if(inc){const inp=inc.parentElement.querySelector('[data-cart-quantity]');const q=Number(inp.value)+1;await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:inc.dataset.cartInc,quantity:q})});await renderCart();}
    const menu=e.target.closest('[data-mobile-open]'); if(menu){const d=qs('[data-mobile-drawer]');d.hidden=false;trapFocus(d);}
    const menuClose=e.target.closest('[data-mobile-close]'); if(menuClose)qs('[data-mobile-drawer]').hidden=true;
    const search=e.target.closest('[data-search-open]'); if(search){const d=qs('[data-search-drawer]');d.hidden=false;trapFocus(d);}
    const searchClose=e.target.closest('[data-search-close]'); if(searchClose)qs('[data-search-drawer]').hidden=true;
    const quickAdd=e.target.closest('[data-quick-add]');
    if(quickAdd){
      e.preventDefault();
      quickAdd.setAttribute('aria-busy','true');
      try{await addItems([{id:Number(quickAdd.dataset.quickAdd),quantity:1}]);}
      catch(err){const live=qs('[data-cart-live]'); if(live)live.textContent=err.message;}
      finally{quickAdd.removeAttribute('aria-busy');}
    }
    const bundleAdd=e.target.closest('[data-bundle-add]');
    if(bundleAdd){
      e.preventDefault();
      const id=bundleAdd.dataset.bundleId||'sclptiq-bundle';
      const one=Number(bundleAdd.dataset.variantOne),two=Number(bundleAdd.dataset.variantTwo);
      const st=bundleAdd.closest('section')?.querySelector('[data-bundle-status]');
      bundleAdd.setAttribute('aria-busy','true');
      try{await addItems([{id:one,quantity:1,properties:{'_bundle_id':id,'_bundle_tier':'2'}},{id:two,quantity:1,properties:{'_bundle_id':id,'_bundle_tier':'2'}}]);if(st)st.textContent=t('Toegevoegd aan je winkelmand.','Added to your bag.','Zu deinem Warenkorb hinzugefügt.');}
      catch(err){if(st)st.textContent=err.message;}
      finally{bundleAdd.removeAttribute('aria-busy');}
    }
  });

  document.addEventListener('change',async e=>{
    const input=e.target.closest('[data-cart-quantity]'); if(input){await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:input.dataset.cartQuantity,quantity:Number(input.value)})});await renderCart();}
    const slider=e.target.closest('[data-ba-range]'); if(slider){const wrap=slider.closest('[data-ba]');qs('.ba-slider__after',wrap).style.clipPath=`inset(0 ${100-slider.value}% 0 0)`;qs('.ba-slider__handle',wrap).style.left=slider.value+'%';}
  });

  qsa('[data-quantity-bundles]').forEach(section=>{
    const radios=qsa('[data-tier-radio]',section),status=qs('[data-tier-status]',section),btn=qs('[data-tier-add]',section);
    let tier=1,cream=1,stick=0;
    const render=()=>{qs('[data-cream-count]',section).textContent=cream;qs('[data-stick-count]',section).textContent=stick;btn.disabled=(cream+stick)!==tier;status.textContent=btn.disabled?(lang==='nl'?`Kies precies ${tier} product${tier>1?'en':''}.`:lang==='de'?`Wähle genau ${tier} Produkt${tier>1?'e':''}.`:`Choose exactly ${tier} product${tier>1?'s':''}.`):'';};
    radios.forEach(r=>r.addEventListener('change',()=>{tier=Number(r.value);cream=tier;stick=0;render();}));
    section.addEventListener('click',e=>{
      if(e.target.matches('[data-cream-plus]')&&cream+stick<tier)cream++;
      if(e.target.matches('[data-stick-plus]')&&cream+stick<tier)stick++;
      if(e.target.matches('[data-cream-minus]')&&cream>0)cream--;
      if(e.target.matches('[data-stick-minus]')&&stick>0)stick--;
      if(e.target.matches('[data-cream-plus],[data-stick-plus],[data-cream-minus],[data-stick-minus]'))render();
    });
    let bundleMap={};
    try{bundleMap=JSON.parse(btn.dataset.bundleVariants||'{}');}catch(e){}
    btn?.addEventListener('click',async()=>{
      const key=`${tier}:${cream}:${stick}`;
      const variantId=bundleMap[key];
      if(!variantId){status.textContent=t('Kies je combinatie.','Please choose your combination.','Wähle deine Kombination.');return;}
      btn.disabled=true;
      try{await addItems([{id:Number(variantId),quantity:1}]);status.textContent=t('Toegevoegd aan je winkelmand.','Added to your bag.','Zu deinem Warenkorb hinzugefügt.');}catch(err){status.textContent=err.message;}finally{render();}
    });
    render();
  });

  // UGC: muted autoplay only while in viewport (respects reduced motion)
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ugcVideos = qsa('.video-rail video, .v2-ugc video');
  if (ugcVideos.length && 'IntersectionObserver' in window && !reduceMotion){
    const io = new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        const v = entry.target;
        var wrap = v.closest('.v2-ugc__it');
        if(entry.isIntersecting){ v.muted=true; var p=v.play(); if(p&&p.catch)p.catch(function(){}); if(wrap)wrap.classList.add('is-playing'); }
        else { v.pause(); }
      });
    }, {threshold:0.3});
    ugcVideos.forEach(v=>io.observe(v));
  }

  // Predictive search
  const psInput = qs('[data-predictive-input]');
  const psResults = qs('[data-predictive-results]');
  if (psInput && psResults){
    let psTimer;
    const renderResults = (data)=>{
      const products = (data?.resources?.results?.products)||[];
      if(!products.length){ psResults.innerHTML = psInput.value.trim() ? `<p class="predictive-empty">${t('Nog geen resultaten.','No results yet.','Noch keine Ergebnisse.')}</p>` : ''; return; }
      psResults.innerHTML = '<ul class="predictive-list">' + products.map(p=>`
        <li><a href="${p.url}">
          ${(()=>{const h=(p.url||'').split('/products/')[1]?.split(/[/?#]/)[0];const u=(h&&I18N_IMGS[h])||(p.featured_image&&p.featured_image.url);return u?`<img src="${u}" alt="" width="48" height="48" loading="lazy">`:''})()}
          <span>${p.title}</span>
        </a></li>`).join('') + '</ul>';
    };
    psInput.addEventListener('input', ()=>{
      const q = psInput.value.trim();
      clearTimeout(psTimer);
      if(q.length<2){ psResults.innerHTML=''; return; }
      psTimer = setTimeout(async ()=>{
        try{
          const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const r = await fetch(url,{headers:{Accept:'application/json'}});
          if(!r.ok) return;
          renderResults(await r.json());
        }catch(e){ /* silent */ }
      }, 220);
    });
  }
})();
